import { ManagementMetaStrip } from "../../../shared/ui/management-meta-strip";
import { MANAGEMENT_VARIANT } from "../model/constants";
import { useStandardManagement } from "../model/useStandardManagement";
import { AlertsTableSection } from "./AlertsTableSection";
import { IndeterminateManagementView } from "./IndeterminateManagementView";
import { JourneyDocumentsSection } from "./JourneyDocumentsSection";
import { SolicitudForm } from "./SolicitudForm";
import { StandardManagementModals } from "./StandardManagementModals";
import {
  ActionsRow,
  ManagementBody,
  ManagementCard,
  PrimaryActionButton,
  SecondaryActionButton,
} from "./common.styles";

const StandardManagementWidget = ({
  assignment,
  appliedFilters,
  historyByCategory = { pdf: [], excel: [] },
  managementTypeOptions = [],
  variant = MANAGEMENT_VARIANT.DEFAULT,
  onBack,
  onContinue,
  onSubmitManagementRequest,
}) => {
  const {
    isPriceAdjustment,
    managementTypeLabel,
    observation,
    setObservation,
    alertsData,
    alertsColumns,
    addAlertColumns,
    modalDataSource,
    modalLoading,
    isAddModalOpen,
    setIsAddModalOpen,
    missing,
    setMissing,
    servicesResult,
    closeServicesResult,
    managementMetaItems,
    activePdf,
    activeExcel,
    pdf,
    acta,
    homologation,
    handleDownloadActa,
    submitting,
    submit,
  } = useStandardManagement({
    assignment,
    appliedFilters,
    historyByCategory,
    managementTypeOptions,
    variant,
    onContinue,
    onSubmitManagementRequest,
  });

  return (
    <ManagementCard bordered={false}>
      <ManagementBody>
        <ManagementMetaStrip items={managementMetaItems} />

        <JourneyDocumentsSection
          activePdf={activePdf}
          activeExcel={activeExcel}
          viewingPdf={pdf.loadingRoute}
          onViewPdf={() => pdf.openFromRoute(activePdf?.route, activePdf?.name)}
        />

        <SolicitudForm
          isPriceAdjustment={isPriceAdjustment}
          documentLabel={managementTypeLabel}
          observation={observation}
          onObservationChange={setObservation}
          actaFile={acta.actaFile}
          onBeforeUploadActa={acta.beforeUpload}
          onViewActa={() => pdf.openFromFile(acta.actaFile)}
          onDownloadActa={handleDownloadActa}
          onRemoveActa={acta.clear}
        />

        <AlertsTableSection
          variant={variant}
          columns={alertsColumns}
          dataSource={alertsData}
          onAddItem={() => setIsAddModalOpen(true)}
        />

        <ActionsRow>
          <SecondaryActionButton onClick={onBack}>Cancelar</SecondaryActionButton>
          <PrimaryActionButton type="primary" onClick={submit} loading={submitting}>
            Enviar
          </PrimaryActionButton>
        </ActionsRow>
      </ManagementBody>

      <StandardManagementModals
        pdf={pdf}
        missing={missing}
        onCloseMissing={() => setMissing({ isOpen: false, message: "" })}
        servicesResult={servicesResult}
        onCloseServicesResult={closeServicesResult}
        addModal={{
          isOpen: isAddModalOpen,
          onClose: () => setIsAddModalOpen(false),
          columns: addAlertColumns,
          dataSource: modalDataSource,
          loading: modalLoading,
        }}
        homologation={homologation}
        defaultJourney={appliedFilters?.operationalDay ?? null}
      />
    </ManagementCard>
  );
};

// La gestión INDETERMINADO usa un formulario rico por producto (acordeón), muy
// distinto de la tabla única de las demás variantes: se despacha a su propia vista.
export const AlertedProductsManagementWidget = (props) =>
  props.variant === MANAGEMENT_VARIANT.INDETERMINATE ? (
    <IndeterminateManagementView {...props} />
  ) : (
    <StandardManagementWidget {...props} />
  );